import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Auth/Login';
import Home from '../pages/Home';
import Layout from '../components/layout';
import ContactsView from '../pages/ContactsView';
import MyProfileContainer from '../pages/Profile';
import SettingsContainer from '../pages/Settings/Containers/SettingsContainer';
import CatalogContainer from '../pages/Catalog';
import Connect from '../pages/Connect';
import SignupPage from '../pages/Auth/Sighup';
import ForgotPasswordPage from '../pages/Auth/ForgotPassword';
import ChangePasswordPage from '../pages/Auth/ChangePassword';
import OtpVerifyPage from '../pages/Auth/OtpVerify';


const ProtectedRoute = ({ children }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem('sessionId');
    return token !== null;
  };

  return isAuthenticated() ? (
    <Layout>
      {children}
    </Layout>
  ) : (
    <Navigate to="/" replace />
  );
};


// Public Route Component
const PublicRoute = ({ children }) => {
  const isAuthenticated = () => {
    const token = localStorage.getItem('sessionId');
    return token !== null;
  };

  return isAuthenticated() ? <Navigate to="/app/chats" replace /> : children;
};


function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/register"
        element={
          <PublicRoute>
            <SignupPage />
          </PublicRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PublicRoute>
            <ForgotPasswordPage />
          </PublicRoute>
        }
      />
      <Route
        path="/verify"
        element={
          <PublicRoute>
            <OtpVerifyPage />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/app/chats"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/contacts"
        element={
          <ProtectedRoute>
            <ContactsView />
          </ProtectedRoute>
        }
      />

      <Route
        path="/app/my-profile"
        element={
          <ProtectedRoute>
            <MyProfileContainer />
          </ProtectedRoute>
        }
      />

      <Route
        path="/app/settings"
        element={
          <ProtectedRoute>
            <SettingsContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/catalog/*"
        element={
          <ProtectedRoute>
            <CatalogContainer />
          </ProtectedRoute>
        }
      />
      <Route
        path="/app/messages"
        element={
          <ProtectedRoute>
            <Connect />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />

    </Routes>
  );
}

export default AppRoutes;